import React from "react";
import { GridRow, GridColumn, LabeledText } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../../common/types/Language";
import { ensureSubtitleFileRecordDetails, FileRecordDetails } from "../FileRecordDetails";

interface SubtitleFileRecordLanguagesViewProps {
    fileRecordDetails: FileRecordDetails;
    height: number;
}

export const SubtitleFileRecordLanguagesView = ({
    fileRecordDetails,
    height
}: SubtitleFileRecordLanguagesViewProps): JSX.Element => {
    ensureSubtitleFileRecordDetails(fileRecordDetails);

    return (
        <GridRow style={{ height }}>
            <GridColumn sm={12}>
                <LabeledText
                    testId="file-record-subtitle-field"
                    label="Subtitle"
                    value={fileRecordDetails.subtitle && getLanguageDisplayName(fileRecordDetails.subtitle)}
                />
            </GridColumn>
        </GridRow>
    );
};
